// Submission lock (D46): a sample submitted to CMS is invoiced, so the API
// refuses a change to its data with 423 `sample_locked`. For an MR Manager or
// Program Manager the API client asks, through the dialog mounted in
// Providers, for a reason, and repeats the request with it in this header; the
// backend records the correction in the audit log.

export const LOCKED_CORRECTION_HEADER = 'X-Locked-Correction-Reason'

export interface SampleLockedDetail {
  error: 'sample_locked'
  message: string
  sample_id: string
  sample_name: string
  submitted_on?: string | null
  changes: string[]
  can_correct: boolean
}

export function isSampleLocked(detail: unknown): detail is SampleLockedDetail {
  return (
    typeof detail === 'object' &&
    detail !== null &&
    (detail as { error?: unknown }).error === 'sample_locked'
  )
}

type Prompt = (detail: SampleLockedDetail) => Promise<string | null>

let prompt: Prompt | null = null

// The dialog registers itself here while mounted.
export function registerLockedCorrectionPrompt(fn: Prompt | null): void {
  prompt = fn
}

// The reason the user gave for the correction, or null when they cancelled or
// no dialog is mounted.
export function requestLockedCorrection(detail: SampleLockedDetail): Promise<string | null> {
  return prompt ? prompt(detail) : Promise.resolve(null)
}
